import { z } from "zod";

/**
 * The dataset space detail page's tab ids. Shared by the route's `?tab=`
 * validation and the page body's tab writes — see
 * `admin/integrations/integrations-tabs.ts` for why this is a third module.
 */
export const datasetTab = z.enum(["tables", "dashboards", "agents"]);

export type DatasetTab = z.infer<typeof datasetTab>;
